import CustomerForm from "../components/CustomerForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import { useMutateCustomerHandler } from "../dataHandlers/mutateCustomerHandler";
import {
  DEFAULT_CUSTOMER_TYPE,
  DEFAULT_TAX_SCHEME,
} from "../../../constants/defaults";
import { useState, useEffect } from "react";
import {usePermissions} from "../../../hooks/usePermissions";
import {useActionDeniedSnackbar} from "../../../hooks/useActionDeniedSnackbar";
import { CREATE_CUSTOMER } from '../../../constants/eInvoicePermissions';

const initialData = {
  scheme_agency_id: "",
  company_id: "",
  endpoint_scheme_id: null,
  endpoint_id: "",
  party_tax_scheme: {
    tax_scheme: DEFAULT_TAX_SCHEME,
    company_id: "",
  },
  telephone: "",
  postal_address: {
    street_name: "",
    additional_street_name: "",
    address_line: "",
    city_name: "",
    country_subentity: "",
    country_code: null,
    postal_zone: "",
    country: "",
  },
  email: "",
  party_name_in_local_language: "",
  party_name: "",
  name: "",
  customer_type: DEFAULT_CUSTOMER_TYPE,
};

export default function CreateCustomersPage() {
  useDocumentTitle("New Customer Form");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  // Read the customerType from URL query parameters
  const customerType = searchParams.get("customerType");

  const onCustomerCreated = () => {
    navigate("/customers");
  };

  const { onSubmit, error, isPending } = useMutateCustomerHandler({
    onSuccess: onCustomerCreated,
  });


  useEffect(() => {
    if (loading) {
      return;
    }
    if (!hasEInvoicePermission(CREATE_CUSTOMER)) {
      showActionDeniedSnackbar();
      navigate('/customers', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);


  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    onSubmit(payload, false);
  };

  const handleCancel = async () => navigate("/customers");

  return (
    <Stack direction="column" sx={{ mt: "-2rem" }}>
      <CustomerForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={initialData}
        apiErrors={error}
        customerType={customerType}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
